import React from "react";

import './styles.scss';

import MerchantDropdown from "../MerchantDropdown";

export default ({accountName = '', dropdownItems = []}) => {
  return (
    <MerchantDropdown
      id="account-menu"
      className="merchant-account"
      itemsList={dropdownItems}
      hideCaret
    >
      <div className="merchant-account__desktop">
        {accountName}
      </div>
      <div className="merchant-account__mobile">
        {accountName.slice(0, 1).toUpperCase()}
      </div>
    </MerchantDropdown>
  )
}
